<template>
  <div class="orders-container d-flex flex-column">
    <subnav :links="subnav" heading="Заявки"></subnav>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  export default {
    data: () => ({
      subnav: [
        {
          text: 'Детали и оборудование',
          to: '/orders/equipment',
        },
        {
          text: 'Ингредиенты',
          to: '/orders/ingredients',
        },
      ],
    }),
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/orders.vue